import React, { useCallback, useEffect, useState, FC } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

//Components
import ActivityModal from '../common/ActivityModal';
import ActivityLoading from '../common/ActivityLoading';

//Icons
import { FaPencilAlt, FaRegEye, FaTrash } from 'react-icons/fa';

//Services
import { getActivities, getTeacherActivities } from '../../services/ActivityService';
import { removeActivity } from '../../services/NewGroupService';

//Types
import { ActivityInterface, ModalOptionsInterface } from '../common/Types';

//Styles
import '../common/styles.scss';

const Activities: FC<any> = (props: any) => {
    const [modal, setModal] = useState<ModalOptionsInterface>({ open: false, header: "", body: "", buttons: [] });
    const [activities, setActivities] = useState<Array<ActivityInterface>>([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [allActivities, setAllActivities] = useState<Array<ActivityInterface>>([]);
    const [statusRows, setStatusRows] = useState(false);
    const [statusRow, setStatusRow] = useState(false);

    const [loading, setLoading] = useState(false);

    const history = useHistory();

    const fetchActivities = useCallback(() => {
        const { user } = props;

        if (user.admin) {
            getActivities().then((response: any) => {
                response?.sort((a1: any, a2: any) => a1.name.localeCompare(a2.name));
                setActivities(response as Array<ActivityInterface>);
                setAllActivities(response as Array<ActivityInterface>);
                setLoading(false);

            })
        } else if (user.teacher) {
            getTeacherActivities(user.email).then((response: any) => {
                response?.sort((a1: any, a2: any) => a1.name.localeCompare(a2.name));
                setActivities(response as Array<ActivityInterface>);
                setAllActivities(response as Array<ActivityInterface>);
                setLoading(false);
            })
        }
    }, [props])

    useEffect(() => {
        setLoading(true);
        fetchActivities();
    }, [fetchActivities])

    const goToUpdateActivity = (activity: ActivityInterface) => {
        history.push({ pathname: `/activity/edit/${activity.id}` });
    }

    const goToVisualizeActivity = (activity: ActivityInterface) => {
        history.push({ pathname: `/activity/view/${activity.id}` });
    }


    const inscribedFormatter = (data: { inscribed: any; }, data1: { students_limit: any; }) => {
        return `${data ? data : 0}/${data1.students_limit}`
    };

    const editFormat = (cell: any, data: ActivityInterface) => {
        return (
            <div className="buttons-container-center">
                <Button size="sm" style={{ margin: '5px' }} onClick={() => history.push({ pathname: '/activities/activityReport', state: { data: data } })} >Reporte</Button>
                <Button size="sm" style={{ margin: '5px' }} onClick={() => history.push({ pathname: '/activities/new', state: { data: data } })} >Duplicar</Button>
                <Button size="sm" style={{ margin: '5px' }} onClick={() => goToUpdateActivity(data)}>
                    <FaPencilAlt />
                </Button>
                <Button size="sm" style={{ margin: '5px' }} onClick={() => handleDisableActivity(data)}>
                    <FaTrash />
                </Button>
                <Button size="sm" style={{ margin: '5px' }} onClick={() => goToVisualizeActivity(data)}>
                    <FaRegEye />
                </Button>
            </div>
        )

    }

    const columnsTest = [
        {
            dataField: "name",
            text: "Nombre",
            sort: true,
        },
        {
            dataField: "inscribed",
            text: "Inscritos/Límite",
            formatter: inscribedFormatter
        },
        {
            dataField: "nameContact",
            text: "Responsable",
            filter: textFilter({
                delay: 1000,
                placeholder: 'Filtrar por Responsable',
            })

        },
        {
            dataField: "nameCycle",
            text: "Ciclo Escolar",
            filter: textFilter({
                delay: 1000,
                placeholder: 'Filtrar por Ciclo Escolar',
            }),
        },
        {
            dataField: "report",
            text: "Acciones",
            formatter: editFormat
        },
    ]

    const handleDisableActivity = (activity: ActivityInterface) => {
        setModal({
            open: true,
            header: "Borrar",
            body: "Estas seguro de que quieres borrar esta actividad?",
            buttons: [
                { text: "Borrar", func: () => disableActivity(activity) },
                { text: "Cancel", func: handleModalClose }
            ]
        });

    }

    const disableActivity = (activity: ActivityInterface) => {
        setLoading(true);

        if (activity && activity.id) {
            removeActivity(activity.id).then(() => {
                fetchActivities();
                handleModalClose();
            })
        }
    }

    const handleModalClose = () => {
        setModal({ open: false, header: "", body: "", buttons: [] });
    }

    const rowSelectedData = (row: any, isSelected: boolean, rowIndex?: number, e?: any) => {
        if (isSelected)
            setStatusRows(true)
        else
            setStatusRows(false)
        // eslint-disable-next-line array-callback-return
        activities.map((activity: any) => {
            row.forEach((object: any) => {
                if (object.id === activity.id) {
                    activity.isSelected = isSelected;
                }
            });
        });
    }

    const activitySelect = (row: any, isSelected: boolean, rowIndex: number, e?: any) => {
        if (isSelected)
            setStatusRow(true)
        else
            setStatusRow(false)
        // eslint-disable-next-line array-callback-return
        activities.map((activity: any) => {
            if (row.id === activity.id) {
                activity.isSelected = isSelected;
            }
        });
    }

    if (loading) return <ActivityLoading />

    return (
        <Container>
            <div style={{ marginBottom: '10px' }}>
                <h1>Actividades</h1>
            </div>
            <ActivityModal {...modal} onClose={handleModalClose} />
            <div style={{ marginBottom: '15px' }}>
                <Button variant="outline-primary" onClick={() => history.push('/activities/new')}>Agregar actividad</Button>
                {/* eslint-disable-next-line no-dupe-keys */}
                <Button variant="outline-primary" disabled={statusRow || statusRows ? false : true} style={{ margin: '10px' }} onClick={() => history.push({ pathname: '/activities/activityExport', state: { data: activities } })} >Reporte General</Button>
            </div>
            <BootstrapTable data={activities ? activities : []} columns={columnsTest} selectRow={{ mode: 'checkbox', clickToSelect: true, onSelect: (row, isSelected, rowIndex, e) => { activitySelect(row, isSelected, rowIndex, e) }, onSelectAll: (isSelect, rows, e) => { rowSelectedData(rows, isSelect, undefined, e) } }} keyField="id" filter={filterFactory()} />
        </Container>
    )
}

export default Activities;
